import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { VACCINE_DISPATCH, VACCINES, MEDICAL_STAFF, buildUrl } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(VACCINE_DISPATCH.BASE);

// Export service with additional custom methods
export const VaccineDispatchService = {
  ...baseCRUD,

  // Get dropdown options
  getStatuses: () => fetchDropdowns(VACCINE_DISPATCH.STATUSES),
  getCouriers: () => fetchDropdowns(VACCINE_DISPATCH.COURIERS),
  getVaccines: () => fetchDropdowns(VACCINES.BASE),
  getLocations: () => fetchDropdowns('locations'),
  getConditions: () => fetchDropdowns(VACCINE_DISPATCH.CONDITIONS),

  // Receive transfer - POST/PUT
  receiveTransfer: async (transferId, data) => {
    const response = await api.post(VACCINE_DISPATCH.RECEIVE(transferId), data);
    return response.data;
  },

  updateReceive: async (transferId, data) => {
    const response = await api.put(VACCINE_DISPATCH.RECEIVE(transferId), data);
    return response.data;
  },

  // Inspect transfer - POST/PUT
  inspectTransfer: async (transferId, data) => {
    const response = await api.post(VACCINE_DISPATCH.INSPECT(transferId), data);
    return response.data;
  },

  updateInspect: async (transferId, data) => {
    const response = await api.put(VACCINE_DISPATCH.INSPECT(transferId), data);
    return response.data;
  },

  // Get medical staff for dropdowns
  getMedicalStaffDropdown: async (clinicId = null) => {
    const params = { page: 1, limit: 100, isDropdown: true };
    if (clinicId) params.clinicId = clinicId;
    const response = await api.get(buildUrl(MEDICAL_STAFF.BASE, params));
    return response.data;
  },
};

export default VaccineDispatchService;
